module.exports = __webpack_public_path__ + "img/solve_problem_key.2518889b.png";